var ko = require('knockout'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  find = require('lodash/find');

// A new topic which is (currently) used to detect when we add participants to a course
// to indicate that for these participants this course is overlapping with an already chosen course.
var UPDATE_PARTICIPANTS_TOPIC = 'updateParticipantsTopic';

function Model(params) {
  var self = this;
  if (params.addNewEmployeeEndpoint === undefined)
    throw 'addNewEmployeeEndpoint must be set';
  if (params.usersHaveAlreadyBoughtCourseEndpoint === undefined)
    throw 'usersHaveAlreadyBoughtCourseEndpoint must be set';
  if (params.usersHaveAlreadyBoughtOnlineCourseEndpoint === undefined)
    throw 'usersHaveAlreadyBoughtOnlineCourseEndpoint must be set';
  if (params.usersHaveAlreadyBoughtProgramEndpoint === undefined)
    throw 'usersHaveAlreadyBoughtProgramEndpoint must be set';

  self.activePopup = ko.observable(false);
  self.togglePopup = function() {
    self.activePopup(!self.activePopup());
  };

  self.addNewEmployeeEndpoint = params.addNewEmployeeEndpoint;
  self.hasBoughtCourseEndpoint = params.usersHaveAlreadyBoughtCourseEndpoint;
  self.hasBoughtOnlineCourseEndpoint =
    params.usersHaveAlreadyBoughtOnlineCourseEndpoint;
  self.hasBoughtProgramEndpoint = params.usersHaveAlreadyBoughtProgramEndpoint;
  self.usersHaveAlreadyBoughtOverlappingCourseEndpoint =
    params.usersHaveAlreadyBoughtOverlappingCourseEndpoint;
  self.hasOverlappingCourse = ko.observable({});

  // List of employees that are associated with the chosen bureau.
  self.employeeList = params.employeeList;
  // List of courses that the user has in shopping cart.
  self.courseList = params.courseList;
  // The course associated with this participant box.
  self.course = params.course;

  self.hasOverlappingCourseInCart = ko.observable({});
  self.hasBoughtCourseIsChecked = ko.observable(false);
  self.hasBoughtProgramIsChecked = ko.observable(false);
  self.hasBoughtOnlineCourseIsChecked = ko.observable(false);
  self.hasOverlappingCourseIsChecked = ko.observable(false);
  self.showEmployees = ko.computed(function() {
    return (
      (self.course.EventType != 6 && self.course.EventType != 3
        ? self.hasBoughtCourseIsChecked()
        : true) &&
      (self.course.EventType == 3
        ? self.hasBoughtOnlineCourseIsChecked()
        : true) &&
      (self.course.EventType == 6 ? self.hasBoughtProgramIsChecked() : true) &&
      (self.course.EventType != 6 && self.course.EventType != 3
        ? self.hasOverlappingCourseIsChecked()
        : true)
    );
  });

  self.disableCheckbox = function(aktorId) {
    return (
      (self.hasBoughtCourseIsChecked() && self.hasBoughtCourse()[aktorId]) ||
      (self.hasOverlappingCourseIsChecked() &&
        self.hasOverlappingCourse()[aktorId]) ||
      (self.hasBoughtProgramIsChecked() && self.hasBoughtProgram()[aktorId])
    );
  };

  self.checkedEmployees = ko.observableArray([]);
  self.addToAll = ko.observable(false);
  self.hasBoughtCourse = ko.observable();
  self.hasBoughtOnlineCourse = ko.observable();
  self.hasBoughtProgram = ko.observable();
  self.errorText = ko.observable();
  self.normalizeEmployee = function(employee) {
    var normalized = {};
    Object.keys(employee || {}).forEach(function(key) {
      var normalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
      normalized[normalizedKey] = employee[key];
    });
    return normalized;
  };

  // Mark the checkboxes of those participants that are already added to the course.
  self.setCheckedEmployees = function() {
    var tmpCheckedEmployees = [];
    params.participants.forEach(function(participant) {
      var checkedEmployee = find(self.employeeList(), function(o) {
        return o.AktorId === participant.AktorId;
      });
      if (checkedEmployee !== undefined) {
        tmpCheckedEmployees.push(checkedEmployee);
      }
    });
    self.checkedEmployees(tmpCheckedEmployees);
    if (tmpCheckedEmployees.length > 0) {
      cart.registerOverlappingCoursesForParticipants(
        self.course.Id,
        tmpCheckedEmployees,
        UPDATE_PARTICIPANTS_TOPIC
      );
    }
  };

  // When the user clicks the addParticipant button we want to add them to course and check if there are overlaps.
  self.addParticipants = function() {
    var employeesToAdd = self.checkedEmployees();
    if (employeesToAdd.length > 0) {
      if (!self.addToAll()) {
        cart.addParticipantsToCourse(self.course.Id, employeesToAdd);
        cart.registerOverlappingCoursesForParticipants(
          self.course.Id,
          employeesToAdd,
          UPDATE_PARTICIPANTS_TOPIC
        );
      }
    }
    self.addToAll(false);
    self.hasBoughtCourseIsChecked(true);
    self.hasBoughtOnlineCourseIsChecked(true);
    self.hasBoughtProgramIsChecked(true);
    self.hasOverlappingCourseIsChecked(true);
  };

  // Listen to changes when we update participants in the shopping cart.
  ko.postbox.subscribe(
    UPDATE_PARTICIPANTS_TOPIC,
    function(courses) {
      var hasOverlap = false;
      for (var i = 0; i < courses.length; i++) {
        if (
          courses[i].Id === self.course.Id &&
          courses[i].overlappingParticipants
        ) {
          hasOverlap = true;
          self.hasOverlappingCourse(courses[i].overlappingParticipants);
          break;
        }
      }
      // If there were no overlap, we can reset our object.
      if (!hasOverlap) {
        self.hasOverlappingCourse({});
      }
    },
    true,
    true
  );

  self.showList = ko.observable(false);
  self.toggleAddParticipant = function() {
    self.showList(!self.showList());
  };

  self.showCreateButton = ko.observable(cart.isAgencySet());
  ko.postbox.subscribe(
    cart.updateTopic,
    function() {
      self.showCreateButton(cart.isAgencySet());
    },
    true
  );

  self.showCreateDialog = ko.observable(false);
  self.toggleCreateDialog = function() {
    self.showCreateDialog(!self.showCreateDialog());
  };

  self.addNewEmployee = function(employee) {
    var normalizedEmployee = self.normalizeEmployee(employee);
    for (var i = 0; i < self.employeeList().length; i++) {
      if (self.employeeList()[i].AktorId === normalizedEmployee.AktorId) {
        self.showCreateDialog(false);
        return;
      }
    }
    self.employeeList.push(normalizedEmployee);
    self.showCreateDialog(false);
  };
  self.employeeIds = [];
  self.selectedAgency = ko.observable().subscribeTo('chosen_agency', true);

  self.postHasBoughtCourse = function() {
    $.post(self.hasBoughtCourseEndpoint, {
      Users: self.employeeIds,
      SequencePk: self.course.Key
    })
      .success(function(data) {
        self.hasBoughtCourse(data);
        self.hasBoughtCourseIsChecked(true);
        self.hasOverlappingCourseIsChecked(true);
      })
      .fail(function(err) {
        self.errorText(err.responseText);
      });
  };

  self.postHasBoughtOnlineCourse = function() {
    $.post(self.hasBoughtOnlineCourseEndpoint, {
      Users: self.employeeIds,
      SequencePk: self.course.Key
    })
      .success(function(data) {
        self.hasBoughtOnlineCourse(data);
        self.hasBoughtOnlineCourseIsChecked(true);
      })
      .fail(function(err) {
        self.errorText(err.responseText);
      });
  };

  self.postHasBoughtProgram = function() {
    $.post(self.hasBoughtProgramEndpoint, {
      Users: self.employeeIds,
      ProgramKey: self.course.Key
    })
      .success(function(data) {
        self.hasBoughtProgram(data);
        self.hasBoughtProgramIsChecked(true);
      })
      .fail(function(err) {
        self.errorText(err.responseText);
      });
  };

  // Listen to changes to the employee list (e.g.: when we change bureau).
  self.employeeListSub = self.employeeList.subscribe(function() {
    if (self.selectedAgency() === 'select_me') {
      return;
    }
    for (var i = 0; i < self.employeeList().length; i++) {
      var foundInList = false;
      for (var j = 0; j < self.employeeIds.length; j++) {
        if (self.employeeList()[i].AktorId === self.employeeIds[j]) {
          foundInList = true;
          continue;
        }
      }
      if (foundInList === false) {
        self.employeeIds.push(self.employeeList()[i].AktorId);
      }
    }
    if (self.employeeIds.length > 0) {
      // Reset the errorText before we call the API's.
      self.errorText();
      self.setCheckedEmployees();
      if (self.course.EventType == 3) {
        self.postHasBoughtOnlineCourse();
      } else if (self.course.EventType == 6) {
        self.postHasBoughtProgram();
      } else {
        self.postHasBoughtCourse();
      }
    }
  });

  //TODO: clean up multiple calls to hasBoughtCourseEndpoint
  if (self.employeeList().length > 0 && self.selectedAgency() !== 'select_me') {
    for (var i = 0; i < self.employeeList().length; i++) {
      var foundInList = false;
      for (var j = 0; j < self.employeeIds.length; j++) {
        if (self.employeeList()[i].AktorId === self.employeeIds[j]) {
          foundInList = true;
          continue;
        }
      }
      if (foundInList === false) {
        self.employeeIds.push(self.employeeList()[i].AktorId);
      }
    }

    self.setCheckedEmployees();
    if (self.course.EventType == 3) {
      self.postHasBoughtOnlineCourse();
    } else if (self.course.EventType == 6) {
      self.postHasBoughtProgram();
    } else {
      self.postHasBoughtCourse();
    }
  }
}

// We need to dispose of our subscription.
Model.prototype.dispose = function() {
  this.employeeListSub.dispose();
};

module.exports = Model;
